export const trackCompleteTest = (arquetipo, session_id) => {
  if (typeof window.fbq !== 'function') return;

  const alreadyTracked = localStorage.getItem(`test_${session_id}`);
  if (alreadyTracked) return;

  window.fbq('trackCustom', 'CompleteTest', {
    arquetipo,
    session_id
  });

  localStorage.setItem(`test_${session_id}`, 'true');
};
